export default __webpack_public_path__ + "static/media/SIFA_NL_SEQ14.85fef3aa.mp3";